import "./Shop.module.css";
import Header from "@/reusable_sections/Header";
import IndustryOverview from "./sections/IndustryOverview";
import ServiceFilterProductGrid from "./sections/ServiceFilterProductGrid";
import Footer from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <Header />
      <IndustryOverview />
      <ServiceFilterProductGrid />
      <Footer />
    </div>;
}